<p class="table-label">{{ tab().labelKey | translate }}</p>
<table class="table" [attr.automation-id]="'canvas-table-' + tab().path">
    <thead>
        <tr>
            <th scope="col" class="row-number"></th>
            @for (columnKey of tab().columnKeys; track $index) {
            <th scope="col">{{ columnKey | translate }}</th>
            }
        </tr>
    </thead>
    <tbody>
        @for (row of tab().rows; track row.id; let index = $index) {
        <tr>
            <td class="row-number">{{ index + 1 }}</td>
            @for (cell of row.cells; track cell.path) {
            <td><p-ai-chat-draft-field-value [value]="cell.value"></p-ai-chat-draft-field-value></td>
            }
        </tr>
        }
    </tbody>
</table>
